import {ref, toRaw} from 'vue'
import { Notify } from 'quasar'
/**
 * https://stackoverflow.com/a/68367336
 */
export default function validationHelper () {
  const errors = ref([])

  function getValidationErrorMessages (field) {
    if (!errors.value) {
      return []
    }
    const keys = Object.keys(errors.value);

    const key = keys.find(element => element.toLowerCase() === field.toLowerCase())
    if (errors.value[key]) {
      return errors.value[key]
    }
    return []
  }

  function getValidationErrors (field) {
    const errors = toRaw(getValidationErrorMessages(field))

    if (errors.length > 0) {
      return errors.join('\r\n')
    }
    return ''
  }

  function hasValidationErrors (field) {
    if (getValidationErrorMessages(field).length > 0) {
      return true
    }
    return false
  }

  function setValidationErrors (payload) {

    let transformed = {};

    for (let key in payload){
      let modifiedKey = key;
      if(key.includes('.')){
        modifiedKey = key.substring(0, key.indexOf('.'))
      }

      transformed[modifiedKey] = payload[key];
    }
console.log(payload)
    errors.value = transformed
  }

  function showValidationError () {
    Notify.create({
      type: 'negative',
      message: 'Validation failure',
      caption: 'please check the inputs'
    })
  }

  function clearValidationErrors () {
    errors.value = {}
  }

  return {
    showValidationError,
    setValidationErrors,
    getValidationErrors,
      clearValidationErrors,
    hasValidationErrors
  }
}
